import React from 'react';
import {createRoot} from 'react-dom/client';
import Modal from './modal';

class CloseModal extends React.Component {

  static showModal(content, className) {
    const container = document.createElement('div');
    window.document.body.appendChild(container);
    const root = createRoot(container);
    const onClose = () => {
      root.unmount();
      container.remove();
    };
    root.render(<CloseModal className={className} onClose={onClose}>{content}</CloseModal>);
  }

  footer(closeModalFn) {
    return <div className="row justify-content-center">
      <button type="button"
              className="btn btn-primary px-5"
              onClick={() => closeModalFn()}>
        {this.props.closeButtonLabel || 'Close'}
      </button>
    </div>
  }

  render() {
    return <Modal className={this.props.className}
                  footer={closeFn => this.footer(closeFn)}
                  onClose={this.props.onClose}>
      {this.props.children}
    </Modal>;
  }

}

export default CloseModal;
